import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ADDON_PRODUCT_KIND, MarketingCharacteristics } from '@app/constants';
import { ShopAddonsLink } from '@app/router/constants';
import { useNavigate } from '@app/hooks';
import { setCurrentShopAddonId } from '@app/redux/addOns';

import { ProductType } from '@mfe/shared/schema-types';
import { getCharacteristicValue } from '@mfe/shared/utils';

import AddonsGridItem from '../AddonsGrid/addons-grid-item';
import { getDescription, getPriceAndDiscount } from '../../utils';
import { AddonsGridItemType, GetPriceAndDiscountResult } from '../../types';

const StandaloneAddon = ({ addon }: { addon: ProductType }) => {
  const { t } = useTranslation('ShopAddons');
  const dispatch = useDispatch();
  const { goTo } = useNavigate();

  const badgeText = useMemo(() => {
    if (addon.kind === ADDON_PRODUCT_KIND.voice) {
      return t('selectAddon.voiceBadgeText');
    }
  }, [addon.kind, t]);

  const {
    price,
    oldPrice,
    promotions = [],
    totalPromotionDuration,
  }: GetPriceAndDiscountResult = getPriceAndDiscount(addon);

  const title =
    getCharacteristicValue(addon.marketing_copy.translations[0].characteristics, MarketingCharacteristics.OFFER_NAME) ??
    addon.name;

  const description = getDescription(addon);

  const button = {
    text: t('selectAddon.addToPlanCTALabel', { title }),
    onClick: () => {
      dispatch(setCurrentShopAddonId(addon.id));
      goTo(`${ShopAddonsLink.ShopAddons}/${ShopAddonsLink.SingleAddon}`);
    },
  };

  const passedProps: AddonsGridItemType = {
    kind: addon.kind,
    title,
    badgeText,
    oldPrice,
    price,
    promotions,
    description,
    button,
    totalPromotionDuration,
    isGroupedProduct: false,
  };

  return <AddonsGridItem {...passedProps} />;
};

export default StandaloneAddon;
